import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  @ViewChild('videoPlayer') videoplayer: any;
  @ViewChild('videoDiv') videoDiv: ElementRef;

  private videoSource = 'assets/video/edwardian-postcards-video.mp4';
  private poster = 'assets/images/poster.png';
  private playing = false;

  constructor() { }

  ngOnInit() {}

  toggleVideo() {
    if (!this.playing) {
      this.playing = true;
      this.videoplayer.nativeElement.play();
    } else {
      this.playing = false;
      this.videoplayer.nativeElement.pause(); }
  }

}
